import React from "react";

import gitbook from "../assets/images/gitbook.svg"
import mirror from "../assets/images/mirror.svg"
import github from "../assets/images/github.svg"
import twitter from "../assets/images/twitter.svg"
import discord from "../assets/images/discord.svg"

export const Footer: React.FC = ({ children }) => {
  return (
    <div className="flex flex-row justify-end items-center top-0 z-40 bg-black2 h-20 w-full py-4 px-4 md:px-10">
      <div className="flex flex-row">
        <a href="https://mirror.xyz/0xEa8459cbA0A12966c700d1737E88d17Cb29a4E73" target="_blank" rel="noreferrer">
          <img src={mirror} alt="Mirror"/>
        </a>
        <a href="https://psy-stablecoin.gitbook.io/psy/" target="_blank" rel="noreferrer" className="ml-4">
          <img src={gitbook} alt="Gitbook"/>
        </a>
        <a href="https://twitter.com/PSY_stablecoin" target="_blank" rel="noreferrer" className="ml-4">
          <img src={twitter} alt="Twitter"/>
        </a>

        <a href="https://discord.gg/EhVkXqQBhr" target="_blank" rel="noreferrer" className="ml-4">
          <img src={discord} alt="Discord"/>
        </a>
        <a href="https://github.com/psystablecoin/" target="_blank" rel="noreferrer" className="ml-4">
          <img src={github} alt="Github"/>
        </a>
      </div>
    </div>
  );
};
